'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'star-half-stroke';
var width = 576;
var height = 512;
var aliases = ["star-half-alt"];
var unicode = 'f5c0';
var svgPathData = 'M324.1 17.6l56.6 111c89.6 14.2 156.6 24.9 201.1 32-31.9 31.9-79.8 79.9-143.9 144.1 14.1 89.6 24.7 156.6 31.7 201.2-40.2-20.4-100.7-51.2-181.5-92.3-80.8 41.1-141.3 71.9-181.5 92.3 7-44.5 17.6-111.6 31.7-201.2-64.1-64.2-112-112.2-143.9-144.1 44.5-7.1 111.6-17.7 201.1-32 41.2-80.8 72.1-141.2 92.6-181.4l35.9 70.4zm46.6 174.2l-32.2-5.1c-6.4-12.6-23.2-45.4-50.4-98.7l0 253.7c12.6 6.4 45.5 23.1 98.7 50.2-9.3-59-15.1-95.5-17.3-109.4 10-10 36.1-36.1 78.3-78.4l-77.3-12.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;